import { render, staticRenderFns } from "./selectedProduct.vue?vue&type=template&id=912460de&scoped=true"
import script from "./selectedProduct.vue?vue&type=script&lang=js"
export * from "./selectedProduct.vue?vue&type=script&lang=js"
import style0 from "./selectedProduct.vue?vue&type=style&index=0&id=912460de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912460de",
  null
  
)

export default component.exports